import React, { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import Navbar from "react-bootstrap/Navbar";
import { AppContext } from "./libs/contextLib";
import { useHistory } from "react-router-dom";
import "./App.css";
import Routes from "./Routes";
import Nav from "react-bootstrap/Nav";
import { onError } from "./libs/errorLib";
import {  MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';


//import LogoutIcon from '@material-ui/icons/Logout';
import iLogo from "./images/logo-main.png";
import pinIcon from'./images/pin.svg';


import { LinkContainer } from "react-router-bootstrap";


import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';


import { Link } from 'react-router-dom';


import { makeStyles, withStyles } from '@material-ui/core/styles';

const FooterTypography = withStyles({
  root: {
    color: "#fff"
  }
})(Typography);



const theme = createTheme({
  typography: {
    fontFamily: [
      'Montserrat'
    ].join(','),
  },
  palette: {
    primary: {
      //light: '#0fc239',
      main: '#f0c239',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {

      main: '#0cb9c2',
      // dark: will be calculated from palette.secondary.main,
    },
    info: {
  main: '#ff0000',
},

    // error: will use the default color
  },
});



function App() {
  const [isAuthenticated, userHasAuthenticated] = useState(false);
  const [isCampra, userIsCampra] = useState(false);
  const [userName, setUserName] = useState("");
  const [showSites, setShowSites] = useState(false);
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [expanded, setExpanded] = useState(false);
  const history = useHistory();

  let listener = null


  useEffect(() => {
    onLoad();
  }, []);

  useEffect(() => {
    listener = document.addEventListener("scroll", e => {
      setExpanded(false);
    })
    return () => {
      document.removeEventListener("scroll", listener)
    }
  }, [])




  async function onLoad() {
    try {
      await Auth.currentSession();
      const cui = await Auth.currentUserInfo();
      setUserName(cui.attributes.name);
      //userIsCampra(cui.attributes['custom:name']==="CAMpRA" && cui.attributes.email.length==21 && cui.attributes.email.includes("pra@aires"));
      userHasAuthenticated(true);
    }
    catch(e) {
      if (e !== 'No current user') {
        onError(e);
      }
    }

    setIsAuthenticating(false);
  }


  const useViewport = () => {
    const [width, setWidth] = React.useState(window.innerWidth);

    React.useEffect(() => {
      const handleWindowResize = () => setWidth(window.innerWidth);
      window.addEventListener("resize", handleWindowResize);
      return () => window.removeEventListener("resize", handleWindowResize);
    }, []);

    // Return the width so we can use it in our components
    return { width };
  }

  const { width } = useViewport();
  const breakpoint = 768;

  async function handleLogout() {
    await Auth.signOut();
    userHasAuthenticated(false);
    userIsCampra(false);
    history.push("/");
  }
  function handleAccount(event) {
    event.preventDefault();
    history.push("/account");
    setExpanded(false);
  }
  function handleHub(event) {
    event.preventDefault();
    history.push("/");
    setExpanded(false);
  }
  function handleAbout(event) {
    event.preventDefault();
    history.push("/about");
    setExpanded(false);
  }
  function handleLogin(event) {
    event.preventDefault();
    history.push("/login");
    setExpanded(false);

  }
  function handleSignup(event) {
    event.preventDefault();
    history.push("/signup");
    setExpanded(false);
  }

  function handleThinking(event) {
    event.preventDefault();
    history.push("/hosting");
    setExpanded(false);
  }

  function handleContactClick(event) {
    event.preventDefault();
    history.push("/contact");
  }



  return (
    !isAuthenticating && (
      <MuiThemeProvider theme={theme}>
       <CssBaseline/>
      <div className="mobile-container" >
        <Navbar collapseOnSelect  expanded={expanded} bg="" variant="light" expand="sm"  style={{background:'#0cb9c2', left:0, paddingLeft: 0, paddingRight: 8, paddingBottom: 6, paddingTop: 8, borderBottom: '2px solid #f0c239'}}>
          <LinkContainer to="/">
            <Navbar.Brand  onClick={() => setExpanded(expanded ? false : "")}>
            <img
              src={iLogo}
              width="auto"
              height="28"
              style={{marginLeft: 16}}
              className="d-inline-block align-top"
              alt="SPiVolt"
              />

            </Navbar.Brand>


          </LinkContainer>

          <Navbar.Toggle style={width>breakpoint?{}:{marginRight: 16}}   onClick={() => setExpanded(expanded ? false : "expanded")} onBlur={() => setExpanded(false)}/>
          <Navbar.Collapse className="justify-content-end" >
              {isAuthenticated ?
                (isCampra ?
                <Nav activeKey={window.location.pathname} onClick={() => setExpanded(false)} onBlur={() => setExpanded(false)}>
                <Nav.Link className={width>breakpoint?"":"ml-auto"} style={width>breakpoint?{}:{marginLeft: 16, marginRight: 22}} onMouseDown={handleAccount} onBlur={() => setExpanded(false)}>
                <Box display="flex" ajustifyContent="center" alignItems="center" flexWrap="nowrap" whiteSpace="nowrap">
                <span class="material-icons-round" style={{ color: "#555", fontSize: "16px"}}>
                  account_circle
                </span>
                &nbsp;{userName}
                </Box>
                </Nav.Link>
                <Nav.Link className={width>breakpoint?"":"ml-auto"} style={width>breakpoint?{}:{marginLeft: 16, marginRight: 22}} onMouseDown={handleLogout}>
                <Box display="flex" ajustifyContent="center" alignItems="center" flexWrap="nowrap" whiteSpace="nowrap">
                &nbsp;Logout
                </Box>
                </Nav.Link>
                </Nav>
               :
                <Nav activeKey={window.location.pathname} onClick={() => setExpanded(false)} onBlur={() => setExpanded(false)}>
                <Nav.Link className={width>breakpoint?"":"ml-auto"} style={width>breakpoint?{}:{marginLeft: 16, marginRight: 22}} onMouseDown={handleAccount} onBlur={() => setExpanded(false)}>
                <Box display="flex" ajustifyContent="center" alignItems="center" flexWrap="nowrap" whiteSpace="nowrap">
                <span class="material-icons-round" style={{ color: "#555", fontSize: "16px"}}>
                  account_circle
                </span>
                &nbsp;{userName}
                </Box>
                </Nav.Link>
                <Nav.Link className={width>breakpoint?"":"ml-auto"} style={width>breakpoint?{}:{marginLeft: 16, marginRight: 22}} onMouseDown={handleHub}>
                <Box display="flex" ajustifyContent="center" alignItems="center" flexWrap="nowrap" whiteSpace="nowrap">
                &nbsp;Sites Hub
                </Box>
                </Nav.Link>
                <Nav.Link className={width>breakpoint?"":"ml-auto"} style={width>breakpoint?{}:{marginLeft: 16, marginRight: 22}} onMouseDown={handleLogout}>
                <Box display="flex" ajustifyContent="center" alignItems="center" flexWrap="nowrap" whiteSpace="nowrap">
                &nbsp;Logout
                </Box>
                </Nav.Link>
                </Nav>

              ) : (
                <Nav  activeKey={window.location.pathname} onClick={() => setExpanded(false)} onBlur={() => setExpanded(false)}>
                  {/*<Nav.Link className={width>breakpoint?"":"ml-auto"} style={width>breakpoint?{}:{marginLeft: 16, marginRight: 22}} onMouseDown={handleAbout} onBlur={() => setExpanded(false)}>
                  <Box display="flex" ajustifyContent="center" alignItems="center" flexWrap="nowrap" whiteSpace="nowrap">
                  &nbsp;About
                  </Box>
                  </Nav.Link>*/}
                  <Nav.Link className={width>breakpoint?"":"ml-auto"} style={width>breakpoint?{}:{marginLeft: 16, marginRight: 22}} onMouseDown={handleSignup}>
                  <Box display="flex" ajustifyContent="center" alignItems="center" flexWrap="nowrap" whiteSpace="nowrap">
                  &nbsp;Signup
                  </Box>
                  </Nav.Link>
                  <Nav.Link className={width>breakpoint?"":"ml-auto"} style={width>breakpoint?{}:{marginLeft: 16, marginRight: 22}} onMouseDown={handleLogin}>
                  <Box display="flex" ajustifyContent="center" alignItems="center" flexWrap="nowrap" whiteSpace="nowrap">
                  &nbsp;Login
                  </Box>
                  </Nav.Link>
                </Nav>
              )}

          </Navbar.Collapse>
        </Navbar>
        <AppContext.Provider value={{ isAuthenticated, userHasAuthenticated, isCampra, userIsCampra, showSites, setShowSites, userName, setUserName}}>
          <Routes />
        </AppContext.Provider>
      </div>
      <Box
      position="sticky"
      bottom="0px"
      left="0px"
      right="0px"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      width="100%"
      bgcolor="#0cb9c2">

      <Divider width="100%" style={{ background: '#f0c239' }}/>

      {/*}
      <Box display="flex" p={1} width="100%">
      <Box p={0} flexGrow={1}>
      <FooterTypography variant="caption">SPIVOLT<sup><small>TM</small></sup> LIMITED<br/>
      Company No. ?????????<br/>
      <Link style={{color:"white"}} onClick={handleContactClick} >Contact us</Link>
      </FooterTypography>
      </Box>
      <Box p={0} display="flex" flexDirection="column">
      <a style={{color:"white", fontSize:"12px", textAlign:"right"}} href={"https://spivolt.com/docs/faqs.pdf"} target="_blank">FAQs</a>
      <Box style={{textAlign:"right"}} py={0.5}><a style={{color:"white", fontSize:"12px", textAlign:"right"}} href={"https://spivolt.com/docs/privacy.pdf"} target="_blank">Privacy</a></Box>
      <a style={{color:"white", fontSize:"12px", textAlign:"right"}} href={"https://spivolt.com/docs/tncs.pdf"} target="_blank">Terms of Use</a>
      </Box>
      </Box>
      */}

      <Box width="100%" mt={0.5} mb={0.5} pl={1} pr={1} style={{textAlign:"right"}}><a style={{color:"#fff", fontSize:"11px", textAlign:"left"}} >©2022 SPiVolt Limited. All rights reserved.</a></Box>

      </Box>
{/*}
      <Box
      position="sticky"
      bottom="0px"
      left="0px"
      right="0px"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      width="100%"
      bgcolor="#0cb9c2">
      <Divider width="100%" style={{ background: '#f0c239' }}/>
      <Box display="flex" p={1} width="100%">
      <Box p={0} flexGrow={1}>
      <FooterTypography variant="caption">SPIVOLT<sup><small>TM</small></sup> LIMITED<br/>
      Company No. ?????????<br/>
      <Link style={{color:"white"}} onClick={handleContactClick} >Contact us</Link>
      </FooterTypography>
      </Box>
      <Box p={0} display="flex" flexDirection="column">
      <a style={{color:"white", fontSize:"12px", textAlign:"right"}} href={"https://spivolt.com/docs/faqs.pdf"} target="_blank">FAQs</a>
      <Box style={{textAlign:"right"}} py={0.5}><a style={{color:"white", fontSize:"12px", textAlign:"right"}} href={"https://spivolt.com/docs/privacy.pdf"} target="_blank">Privacy</a></Box>
      <a style={{color:"white", fontSize:"12px", textAlign:"right"}} href={"https://spivolt.com/docs/tncs.pdf"} target="_blank">Terms of Use</a>
      </Box>
      </Box>
      <Box width="100%" mt={-0.8} pl={1} style={{textAlign:"left"}}><a style={{color:"#fff", fontSize:"10px", textAlign:"left"}} >©2022 SPiVolt Limited. All rights reserved.</a></Box>
      </Box>
      */}

      </MuiThemeProvider>
    )
  );
}

export default App;
